import React, { useEffect, useState } from 'react';
// import 'antd/dist/antd.css';
import { Table, Radio, message, Spin, Modal, Button, Row, Col, Card } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import efn from './AnnouncementFns'
import langObj from '../TopUserLang'
import './Announcement.scss';
import DraggableTable from './DraggableTable'

function Announcement(props) {
  const navigate = useNavigate()
  const location = useLocation()
  const [announcements, setAnnouncements] = useState([])
  const [isPageLoading, setIsPageLoading] = useState(true)
  const [isTableLoading, setIsTableLoading] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [modalTitle, setModalTitle] = useState("")
  const [modalContent, setModalContent] = useState()
  const [cnSortChange, setCnSortChange] = useState([])
  const [enSortChange, setEnSortChange] = useState([])
  const [isButtonSortLoading, setIsButtonSortLoading] = useState(false)
  const [cnAnnouncements, setCnAnnouncements] = useState([])
  const [mode, setMode] = useState('All');
  const handleModeChange = (e) => {
    setMode(e.target.value);
  };
  const setFuncMap = {
    setAnnouncements, setIsPageLoading, setIsModalOpen,
    setIsTableLoading, setModalTitle, setModalContent,
    message, setCnSortChange, setEnSortChange, setIsButtonSortLoading
  }
  const columns = efn.generateAnnouncementMenu(props, setFuncMap)
  const moveColumns = efn.generateAnnouncementMoveMenu(props, setFuncMap)
  useEffect(() => {
    setCnAnnouncements(efn.getLangSortedAnnouncements(announcements, "CN"))
  }, [announcements])

  // let cnAnnouncements = efn.getLangSortedAnnouncements(announcements, "CN")
  let enAnnouncements = efn.getLangSortedAnnouncements(announcements, "EN")
  useEffect(() => {

    efn.getAnnouncements(props, setFuncMap)
    efn.getConference(props, setFuncMap)

  }, []);

  return (
    <Spin spinning={isPageLoading}>
      <div className="Announcement">
        <Row gutter={16} justify="end">
          {mode === "CN" && cnSortChange.length > 0 && <Col>
            <Button type="primary" loading={isButtonSortLoading}
              onClick={() => { efn.updateAnnouncementsSort(mode, cnSortChange, props, setFuncMap) }}>更新排序</Button>
          </Col>}
          {mode === "EN" && enSortChange.length > 0 && <Col>
            <Button type="primary" loading={isButtonSortLoading}
              onClick={() => { efn.updateAnnouncementsSort(mode, enSortChange, props, setFuncMap) }}>更新排序</Button>
          </Col>}
          <Col>
            <Button type="primary" onClick={() => { efn.openAnnouncementCreatePage(props.conferenceUid, "建立公告", setFuncMap) }}>建立公告</Button>
          </Col>
        </Row>
        <Spin spinning={isTableLoading}>
          <Radio.Group
            onChange={handleModeChange}
            value={mode}
            style={{
              marginBottom: 8,
            }}
          >
            {langObj.langsWithAll.map((lang, key) => {
              return <Radio.Button key={key} value={lang.key} style={{ background: lang.color }}>{lang.key}</Radio.Button>
            })}
          </Radio.Group>
          {mode === "All" && <Table dataSource={announcements} columns={columns} />}
          {mode === "EN" && <DraggableTable dataSource={enAnnouncements}
            columns={moveColumns}
            setFuncMap={setFuncMap}
            mode="EN" />}
          {mode === "CN" && <DraggableTable dataSource={cnAnnouncements}
            columns={moveColumns}
            setFuncMap={setFuncMap}
            mode="CN" />}

        </Spin>
        <Modal wrapClassName="modal-theme" width="80%" title={modalTitle} open={isModalOpen} footer={[]} destroyOnClose
          onCancel={() => { setIsModalOpen(false) }}>
          {modalContent}
        </Modal>
      </div>
    </Spin>
  );
}



export default Announcement;
